class Store<T = object> {
  constructor(readonly parent: T) {}

  get store(): T {
    const store = this.getStore(this.parent)
    if (!store) throw new Error('Store not found')
    return store
  }

  private getStore = (parent: T): T | undefined => {
    if (!(parent instanceof Store)) return parent
    else if (parent.parent) return this.getStore(parent.parent)
    return undefined
  }
}

export default Store
